exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1b4tbm1qjYyePOPUvWDe73 {\n  color: #8B8B8B;\n  font-size: 16px;\n  font-weight: bold;\n  margin-left: 15px;\n  height: auto;\n  margin-top: 15px;\n}\n\n._28Uu5SPTWKXkcB-vsRXutE {\n  margin-top: 80px;\n}\n\n._2WYn2HPAomfS3fAgW4-b91 {\n  font-size: 16px;\n  margin-left: 30px;\n  margin-left: 20px;\n}", ""]);

// exports
exports.locals = {
	"paneText": "_1b4tbm1qjYyePOPUvWDe73",
	"infoPaneWrapper": "_28Uu5SPTWKXkcB-vsRXutE",
	"paneValues": "_2WYn2HPAomfS3fAgW4-b91"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/IDTFRecordingInfoPane/IDTFRecordingInfoPane.css
// module id = 9503
// module chunks = 23